<template>
  <div class="home">
    <div class="box">
      <div class="left">
        <div class="header-title">
          <span class="one">icon</span>
          <span class="two">Home</span>
        </div>
        <div class="left-footer">
          <div class="tab-list">
            <div
              class="list-box"
              @click="contIndex(index, item.value)"
              :class="currendIndex == index ? 'active' : ''"
              v-for="(item, index) in categoryList"
              :key="item.value"
            >
             <img :src="item.icon" alt="">
              {{ item.label }}
            </div>
          </div>
          <img
            class="left-img"
            src="../assets/images/homepage/home.png"
            alt=""
          />
        </div>
      </div>
      <div class="center">
        <div class="center-header" style="justify-content: space-between;">
          <div style="display: flex;">
            <div class="searchinput">
              <sa-input
                clearable
                placeholder="请输入图标关键词"
                prefix-icon="sa-icon-search"
                v-model="searchinput"
                @input="search"
              >
              </sa-input>
            </div>
            <!-- <div class="radiochoose">
              <sa-checkbox v-model="checked">只看已选：<span>{{ 0 }}/{{ total }}</span></sa-checkbox>
            </div> -->
          </div>
          <div>
            <sa-button round @click="handleStart">使用文档</sa-button>
            <sa-button round @click="handleChangeLog">更新日志</sa-button>
          </div>
        </div>

        <div class="contentbox">
          <div class="content" ref="itemList" @scroll="handleScroll">
            <div
              :id="item.category"
              v-for="item in iconList"
              :key="item.iconId"
              class="bigbox"
            >
              <div class="title datasimba" >
                <!-- {{ getCategoryLabel(item.category) }}（{{item.list.length}}） -->
              </div>
              <div class="checkbox-group" :class="`${item.category}-box`">
                <template v-for="icon in item.list">
                  <div
                    class="checkbox-button"
                    :key="icon.iconId"
                  >
                    <div class="wordbox">
                      <span v-if="icon.isNew" style="font-size: 12px;color: red; position: absolute; right: 10px;">new</span>
                      <div style="display: flex; height:72px; padding: 10px;">
                        <div class="icon" style="display: flex;justify-content: center;align-items: center;">
                          <sa-icon :name="icon.name" version="v2" :config="formData"></sa-icon>
                        </div>
                        <div style="margin-left: 10px; display: flex; flex-direction: column; height: 100%; justify-content: space-around; width: 120px;">
                          <sa-ellipsis lineStatus="single" showOverflowTooltip>
                            {{ icon.name }}
                          </sa-ellipsis>
                          <sa-ellipsis lineStatus="single" showOverflowTooltip>
                            <p class="cname">{{ icon.cName }}</p>
                          </sa-ellipsis>
                        </div>
                      </div>
                    </div>
                    <sa-dropdown placement="bottom" style="position: absolute; top: 22px; right: 10px;">
                      <span class="sa-dropdown-link">...</span>
                      <sa-dropdown-menu placement="top" slot="dropdown">
                        <sa-dropdown-item
                          icon="sa-icon-plus"
                          command="copyVue"
                          v-clipboard:copy="`<sa-icon name=${icon.name} />`"
                          v-clipboard:success="onCopy"
                          >复制Vue代码</sa-dropdown-item>
                      </sa-dropdown-menu>
                    </sa-dropdown>
                  </div>
                </template>
              </div>
            </div>
          </div>

          <div class="config-panel">
            <sa-form :model="formData">
              <sa-form-item label="图标大小">
                <sa-input-number
                  v-model="formData.size"
                  :min="12"
                  :max="48"
                  @change="handleConfigChange"
                ></sa-input-number>
              </sa-form-item>
              <sa-form-item label="线段粗细">
                <sa-input-number
                  v-model="formData.strokeWidth"
                  :min="1"
                  :max="4"
                  @change="handleConfigChange"
                ></sa-input-number>
              </sa-form-item>
              <sa-form-item label="图标风格" label-position="top">
                <sa-radio-group v-model="formData.theme" @change="handleConfigChange">
                  <sa-radio label="outline">线性</sa-radio>
                  <sa-radio label="filled">面性</sa-radio>
                  <sa-radio label="two-tone">双色</sa-radio>
                  <!-- <sa-radio label="multi-color">多色</sa-radio> -->
                </sa-radio-group>
              </sa-form-item>
              <sa-form-item label="端点类型" label-position="top">
                <sa-radio-group v-model="formData.strokeLinecap" @change="handleConfigChange">
                  <sa-radio label="butt">butt</sa-radio>
                  <sa-radio label="round">round</sa-radio>
                  <sa-radio label="square">square</sa-radio>
                </sa-radio-group>
              </sa-form-item>
              <sa-form-item label="拐点类型" label-position="top">
                <sa-radio-group v-model="formData.strokeLinejoin" @change="handleConfigChange">
                  <sa-radio label="miter">miter</sa-radio>
                  <sa-radio label="round">round</sa-radio>
                  <sa-radio label="bevel">bevel</sa-radio>
                </sa-radio-group>
              </sa-form-item>
              <sa-form-item label="描边颜色" v-if="formData.theme === 'outline' || formData.theme === 'two-tone'">
                <sa-color-picker v-model="formData.colors[0]" @change="handleConfigChange"></sa-color-picker>
              </sa-form-item>
              <sa-form-item label="填充颜色" v-if="formData.theme === 'filled' || formData.theme === 'two-tone'">
                <sa-color-picker v-model="formData.colors[1]" @change="handleConfigChange"></sa-color-picker>
              </sa-form-item>
              <!-- {{formData.colors}} -->
            </sa-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import icons from '@/packages/svg/index';

export default {
  name: "Home",
  data() {
    return {
      total: 0,
      checked: false,
      categoryList: [
        {
          label: "通用",
          value: "common-icon",
          icon: require("../assets/images/common.svg"),
        },
      ],
      iconList: [],
      searchinput: "",
      currendIndex: 0,
      scrollY: 0, //左侧列表滑动的y轴坐标
      index: 0,
      formData: {
        size: 48,
        strokeWidth: 4,
        strokeLinecap: 'butt', // 端点
        strokeLinejoin: 'miter', // 拐点
        theme: 'outline',
        isCurrentColor: false,
        colors: ['#333', '#2F88FF', '#FFF', '#43CCF8'], // 自定义颜色
      },
    };
  },
  created() {
    this.iconList = [
      {
        category: '通用',
        list: icons
      }
    ]
    // copy bk
    this._iconList = this.iconList.map(item => {
      return {
        ...item,
        list: [...item.list]
      }
    })
  },
  computed: {
  },
  methods: {
    handleConfigChange() {},
    handleStart() {
      window.location.href='/docs/index.html#/start'
    },
    handleChangeLog() {
      window.location.href='/docs/index.html#/changeLog'
    },
    onCopy() {
      this.$message.success('复制成功');
    },
    getCategoryLabel(value) {
      return (this.categoryList.find((cate) => {
        return cate.value == value;
      }) || {}).label;
    },
    search() {
      this.total = 0;
      this.iconList = this._iconList.map(cate => {
        const list = cate.list.filter(icon => {
            this.total ++;
            return icon.name.indexOf(this.searchinput) != -1  || icon.eName.indexOf(this.searchinput) != -1
          })
        return {
          category: cate.category,
          list,
        }
      })
    },
    checkGroup(icon) {
      icon.isChecked = !icon.isChecked;
    },
    handleScroll(event) {
      this.scrollY = event.target.scrollTop;
    },
    contIndex(index, itemList) {
      this.currendIndex = index;
      // {behavior: "smooth"}滚动效果
      // document.getElementById(itemList).scrollIntoView({oblock:"start"})
      const targer = window.document.getElementById(itemList);
      const target = window.document.getElementsByClassName("contentbox");
      target[0].scrollTop = targer.offsetTop - 90;
    },
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.home {
  min-height: 800px;
  min-width: 1440px;
  .box {
    display: flex;
    .left {
      width: 220px;
      .header-title {
        height: 80px;
        line-height: 80px;
        text-align: center;
        .one {
          font-weight: 600;
          font-size: 28px;
          color: #3b3830;
          padding-right: 5px;
        }
        .two {
          font-weight: 600;
          font-size: 28px;
          color: rgba(52, 143, 108, 1);
        }
      }
      .left-footer {
        position: relative;
        border-radius: 0px 100px 0px 0px;
        background: #348f6c;
        height: calc(100vh - 80px);
        .left-img {
          position: absolute;
          bottom: 40px;
          width: 180px;
          height: 180px;
          margin-left: 20px;
        }
        .tab-list {
          padding-top: 50px;
          margin: 0 20px;
          .list-box {
            padding-left: 32px;
            width: 180px;
            height: 40px;
            cursor: pointer;
            font-size: 16px;
            font-weight: 600;
            color: rgba(255, 255, 255, 0.4);
            display: flex;
            align-items: center;
            margin-bottom: 10px;
            img {
              width: 16px;
              height: 16px;
              margin-right: 12px;
            }
          }
        }
        .active {
          background: rgba(0, 0, 0, 0.2);
          border-radius: 27px;
          color: #fff !important;
          opacity: 1;
          img {
            color: #fff !important;
          }
        }
      }
    }
    .center {
      width: 100%;
      flex: 1;
      height: 100vh;
      .center-header {
        margin: 0 40px;
        display: flex;
        height: 80px;
        line-height: 80px;
        border-bottom: 1px solid #dedede;
        .searchinput {
          ::v-deep .sa-input__inner {
            width: 400px;
            height: 40px;
            background: #f0f0f0;
            border-radius: 20px;
            border: 0;
            font-size: 14px;
          }
        }
        .radiochoose {
          margin-left: 40px;
          ::v-deep .sa-radio__inner {
            border-radius: 4px;
            font-size: 14px;
            font-weight: 400;
            color: #0b150f;
          }
        }
        ::v-deep .sa-checkbox__input.is-checked + .sa-checkbox__label {
          color: #348f6c;
        }
        ::v-deep .sa-checkbox__input.is-checked .sa-checkbox__inner,
        .sa-checkbox__input.is-indeterminate .sa-checkbox__inner {
          background-color: #348f6c;
        }
        ::v-deep .sa-checkbox__inner:hover {
          border-color: #348f6c;
        }
      }
      .contentbox {
        margin-left: 40px;
        display: flex;
        .content {
          flex: 1;
          .bigbox {
            display: flex;
            flex-wrap: wrap;
            .datasimba {
              width: 100%;
              height: 70px;
              line-height: 70px;
              font-size: 22px;
              font-weight: 600;
              color: #0b150f;
            }
            .checkbox-group {
              width: 100%;
              display: flex;
              flex-wrap: wrap;
              justify-content: flex-start;
              .checkbox-button {
                position: relative;
                width: 206px;
                height: 72px;
                margin-right: 12px;
                margin-bottom: 12px;
                background: #fafafa;
                border-radius: 8px;
                border: 1px solid #fafafa;
                cursor: pointer;
                .wordbox {
                  position: relative;
                  .cname {
                    font-size: 12px;
                    color: #939694;
                  }
                }
              }
              .bgcolor {
                background: rgba(234, 245, 241, 1);
                border: 1px solid #348f6c;
                color: #348f6c;
              }
            }
          }
        }
        .config-panel {
          width: 300px;
          margin-top: 70px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.sa-dropdown-menu__item:not(.is-disabled):hover {
    background-color: #e6eefc;
    color: #348f6c;
}
.sa-button {
  border-color: #fff;
  background-color: #F3F3F3;
}
.sa-button:hover {
  color: #348F6C;
  border-color: #EAF5F1;
  background-color: #EAF5F1;
}
</style>
